import { RawEnv } from '@hdms/shared/util-core';

export const environment: RawEnv = {
  production: true,
  gqlEndpoint: '/graphql'
};
